import {
  PAYMENT_CARD as CARD,
  PAYMENT_METHOD as METHOD,
  PAYMENT_CARD,
  PAYMENT_PROVIDER as PROVIDER,
} from '../../helpers';

const DATE_FORMAT = { year: 'numeric', month: 'long', day: 'numeric' };

const URL_IMAGES = 'payments/images';

const OPENPAY_CARDS = [PAYMENT_CARD.AMERICAN_EXPRESS, PAYMENT_CARD.MASTERCARD, PAYMENT_CARD.VISA];

export { CARD, DATE_FORMAT, METHOD, OPENPAY_CARDS, PROVIDER, URL_IMAGES };
